module.exports = __webpack_public_path__ + "img/proyecto_home1.7c7e069a.png";